var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert text-center",class:[`alert-${_vm.infoType}`, ..._vm.addedClassList],style:({
  top: `${_vm.top}px`,
  left: `${_vm.left}px`,
  'z-index': _vm.isMobile ? 10 : 4
}),attrs:{"role":"alert"}},[_c('div',{staticClass:"d-flex w-100"},[_c('strong',[_c('fa',{attrs:{"icon":_vm.infoType === 'success' ? 'check' : 'exclamation-circle'}}),_c('span',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.infoText)}})],1),_c('span',{staticClass:"icon__close text-white",on:{"click":_vm.closeInfoBanner}},[_c('fa',{attrs:{"icon":"times"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }